import {
  CheckboxCircleGray300UncheckedIcon,
  CheckboxCirclePrimaryCheckedIcon,
  CheckboxSquareEmptyPrimaryUncheckedIcon,
  CheckboxSquarePrimaryCheckedIcon,
  CheckboxSquarePrimaryUncheckedIcon
} from '@assets/iconComponents';
import { Checkbox as MuiCheckbox, CheckboxProps } from '@mui/material';

interface ICheckboxProps extends CheckboxProps {
  type?: 'square' | 'square_empty' | 'circle';
}

export const Checkbox = (props: ICheckboxProps) => {
  const { type = 'square', ...checkboxprops } = props;

  // 아이콘 선택 로직
  let defaultIcon;
  let checkedIcon;

  if (type === 'square') {
    defaultIcon = <CheckboxSquarePrimaryUncheckedIcon />;
    checkedIcon = <CheckboxSquarePrimaryCheckedIcon />;
  } else if (type === 'square_empty') {
    defaultIcon = <CheckboxSquareEmptyPrimaryUncheckedIcon />;
    checkedIcon = <CheckboxSquarePrimaryCheckedIcon />;
  } else {
    defaultIcon = <CheckboxCircleGray300UncheckedIcon />;
    checkedIcon = <CheckboxCirclePrimaryCheckedIcon />;
  }

  return <MuiCheckbox {...checkboxprops} icon={defaultIcon} checkedIcon={checkedIcon} />;
};
